import React, { FunctionComponent, ReactNode } from 'react'
import { Portal } from '@afterpaytouch/core'
import styles from './style.module.css'
import clsx from 'clsx'

interface DisabledModalProps {
  darkOverlay?: boolean
  lightOverlay?: boolean
  children?: ReactNode
  whiteOverlay?: boolean
  showLoaderOnly?: boolean
}

export const DisabledModal: FunctionComponent<DisabledModalProps> = ({ children, darkOverlay = false, lightOverlay, whiteOverlay = false }) => {
  const className = clsx(styles.container, darkOverlay && styles.darkOverlay, lightOverlay && styles.lightOverlay, whiteOverlay && styles.whiteOverlay)
  return (
    <Portal>
      <div className={className} />
      {children}
    </Portal>
  )
}
